/**
 * Rideau partagé — loader 1ʳᵉ visite + page-transition Barba.
 * Une seule case / un seul jeu de tokens (MOTION.curtain).
 *
 * Cover (leave)  : colonnes depuis le bas (yPercent 100 → 0)
 * Open  (enter / loader exit) : colonnes sortent vers le haut (→ -100)
 *   → l’écran s’ouvre depuis le bas
 */
import { CustomEase } from "gsap/CustomEase";
import { MOTION } from "./tokens";

export const CURTAIN_EASE = CustomEase.create("feuCurtain", "0.5, 0, 0.18, 1");

const c = MOTION.curtain || {};

export const curtainTokens = Object.freeze({
	colDur: c.colDur ?? 0.72,
	colDurIn: c.colDurIn ?? 0.72,
	colDurOut: c.colDurOut ?? 0.72,
	colStagger: c.colStagger ?? 0.09,
	minHoldMs: c.minHoldMs ?? 180,
	revealAt: c.revealAt ?? 0.32,
	/** Leave : colonnes partent de sous l’écran */
	coverFrom: 100,
	/** Enter / loader exit : colonnes sortent par le haut → ouverture depuis le bas */
	openTo: -100,
});

/** Vars GSAP communes pour la sortie colonnes (loader + PT enter). */
export function curtainOpenProps() {
	return {
		yPercent: curtainTokens.openTo,
		duration: curtainTokens.colDurOut,
		ease: CURTAIN_EASE,
		stagger: curtainTokens.colStagger,
		force3D: true,
	};
}

/** Vars GSAP communes pour la couverture (PT leave). */
export function curtainCoverProps() {
	return {
		yPercent: 0,
		duration: curtainTokens.colDurIn,
		ease: CURTAIN_EASE,
		stagger: curtainTokens.colStagger,
		force3D: true,
	};
}
